// Carries the recipient's address on a cockpit CTA so the login form can prefill it. A convenience only —
// nothing treats it as evidence of who the visitor is.
export const PARTNER_COCKPIT_PREFILL_EMAIL_PARAM = 'prefillEmail';
